<template>
<div class="outer-element" v-bind:class="mainTheme">
    <div class="set-position">
        <div class="main">
            <p><strong>Free Writing</strong></p>
            <p>Begin typing, rememebr if you pause too long all is gone.</p>
            <div v-if="inputarea">
            <button class="freewrite-btn" v-on:click="startWriting">Start</button>
            </div>

            <div v-else>
            <button class="freewrite-btn" v-on:click="restartWriting">Stop</button>
            <div class="terminal-input">
                  <textarea autofocus="autofocus" tabindex="-1" rows="25" cols="60" v-model="textEntered"></textarea>
            </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'FreeWriting',
  data () {
    return {
      textEntered: '',
      theme: 'theme_main',
      inputarea: true
    }
  },
  methods: {
    startWriting: function () {
      this.inputarea = false
    },
    restartWriting: function () {
      this.inputarea = true
      this.textEntered = ''
    }
  }
}
</script>

<style scoped>
.outer-element {
  height: 100vh;
}

.set-position {
  padding-top: 150px;
}

.main {
  width: 700px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

textarea {
    resize: none;
    font-family: "courier-prime",monospace;
    font-size: 16px;
    border: none;
}

.theme_main textarea, textarea:focus {
  border: none;
  outline: none;
  background-color:transparent;
  caret-color: #D33983;
  width: 500px;
}
.freewrite-btn {
  border: none;
  background: #fff;
  color: blue;
  font-size: 16px;
  font-family: "courier-prime",monospace;
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: underline;
  padding-left: 0px;


}

</style>



// WEBPACK FOOTER //
// src/components/FreeWriting.vue